module.exports = __webpack_public_path__ + "img/logo.f8bd1711.png";